import React from "react";
import { Checkbox } from "antd";

import { formatNumber } from "../../../services";

import styles from "./mobileCategory.scss";

const MobileCategory = ({
  checked,
  count,
  name,
  onClick,
  hideCheckBox,
  onBoxClick,
  className
}) => (
  <div className={`${styles.category} ${className || ""}`}>
    <Checkbox
      checked={checked}
      className={`
        ${styles.nameHolder}
        ${hideCheckBox ? styles.hideCheckBox : ""}
        ${checked ? styles.checked : ""}
      `}
      // @ts-ignore
      onClick={onClick}
    >
      <span className={styles.name}>{name}</span>
      {count ? (
        <span className={styles.number}>{formatNumber(count)}</span>
      ) : null}
    </Checkbox>

    {!onBoxClick || !checked ? null : (
      <span
        className={styles.fakeBox}
        role="presentation"
        onClick={e => {
          e.preventDefault();
          onBoxClick();
        }}
      ></span>
    )}
  </div>
);

MobileCategory.defaultProps = {
  checked: false,
  count: null,
  hideCheckBox: true,
  className: "",
  onBoxClick: null
};

export default MobileCategory;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/MobileCategory/index.tsx